(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["waitlist"] && !Shopify.designMode) return;
  try {
    
  /* vartai: paskutine para rodo laika iki starto valandomis, minutemis ir sekundemis, po starto atsidaro patys */
  const vartuSaknis = document.documentElement;
  const vartuAntraste = document.querySelector('.capri__drop');
  const vartuPasiulymas = document.querySelector('.capri__offer');
  const vartuPirma = vartuAntraste && vartuAntraste.querySelector('span');
  const vartuUodega = vartuAntraste && vartuAntraste.querySelector('.capri__tail');
  const dvi = (x) => String(x).padStart(2, '0');
  const vartuLaikas = () => {
    const v = window.CF_VARTAI;
    if (!v || !vartuAntraste || !vartuUodega) return;
    const n = Date.now();
    const turi = /(^|;\s*)cf_early=1/.test(document.cookie);
    if (n >= v.startas || (n >= v.ankstyva && turi)) {
      vartuSaknis.classList.remove('uzdaryta', 'ankstyva');
      vartuSaknis.classList.add('atidaryta');
      clearInterval(vartuLaikmatis);
      return;
    }
    const s = Math.max(0, Math.floor((v.startas - n) / 1000));
    if (s > 86400) {
      const dienos = Math.ceil(s / 86400);
      vartuUodega.textContent = vartuAntraste.dataset.count.replace('{days}', dienos);
      return;
    }
    const laikas = Math.floor(s / 3600) + 'h ' + dvi(Math.floor((s % 3600) / 60)) + 'm ' + dvi(s % 60) + 's';
    vartuSaknis.classList.add('su-laikmaciu');
    if (n >= v.ankstyva) {
      vartuSaknis.classList.add('ankstyva');
      if (vartuPirma) vartuPirma.textContent = vartuAntraste.dataset.earlyLine;
      vartuUodega.textContent = 'in ' + laikas + '.';
      if (vartuPasiulymas && vartuAntraste.dataset.earlyOffer) vartuPasiulymas.textContent = vartuAntraste.dataset.earlyOffer;
    } else {
      vartuUodega.textContent = vartuAntraste.dataset.timer.replace('{time}', laikas);
    }
  };
  let vartuLaikmatis;
  if (vartuSaknis.classList.contains('uzdaryta')) {
    vartuLaikas();
    vartuLaikmatis = setInterval(vartuLaikas, 1000);
  }

  const capsule = document.getElementById('capri-capsule');
  const open = document.getElementById('capri-open');
  const email = document.getElementById('capri-email');

  if (capsule && open && email) {
    const openCapsule = () => {
      capsule.classList.add('is-open');
      setTimeout(() => email.focus(), 180);
    };

    const closeCapsule = () => capsule.classList.remove('is-open');

    open.addEventListener('click', openCapsule);

    email.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !email.value.trim()) {
        closeCapsule();
        open.focus();
      }
    });

    capsule.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!capsule.contains(document.activeElement) && !email.value.trim()) closeCapsule();
      }, 0);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
